export class FrontendError {
    public readonly frontend = 'LEARN';

    constructor(public date: Date,
                public message: string,
                public stack: string,
                public innerError: FrontendError | undefined,
                public url: string,
                public browser: string,
                public userId: string | undefined,
                public localUserId: string) {
    }
}
